import {Injectable, Injector} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {LaunchDialogService} from '@spartacus/storefront';
import {DelegoRapidpayService} from '@app/payment/services/delego-rapidpay/delego-rapidpay.service';
import {DcpCartDecoratorService} from '@app/services/dcp-cart-decorator.service';

@Injectable({
  providedIn: 'root',
})
export class ThreeDsService {
  private cancelThreeDsSubject = new Subject<boolean>();

  constructor(
    private delegoService: DelegoRapidpayService,
    private launchDialogService: LaunchDialogService,
    private injector: Injector
  ) {}

  public cancelThreeDs$(): Observable<boolean> {
    return this.cancelThreeDsSubject.asObservable();
  }

  cancelThreeDs(): void {
    this.cancelThreeDsSubject.next(true);
    this.injector.get(DcpCartDecoratorService).setIsPlaceOrderPending(false);

    this.delegoService.destroyIFrame(); // Delego
    this.launchDialogService.closeDialog('Navigation url has changed'); // CyberSource
  }
}
